export const QuotationDeliveryType = [
  "Sea Shipment",
  "Airline",
  "Hand Carry",
  "Domestic Delivery",
]
